/* eslint-disable react-hooks-extra/no-direct-set-state-in-use-effect */
import type { ReactNode } from 'react';

import { useEffect, useMemo, useState } from 'react';

import type { LegacyContext as LegacyContextType, LegacyValue } from '@/config/legacy';

import { LEGACY_FEATURE_KEY, LegacyContext } from '@/config/legacy';

export type LegacyProviderProps = {
    children: ReactNode;
};

export function LegacyProvider({ children }: LegacyProviderProps) {
    const [legacy, setLegacy] = useState<boolean | null>(null);

    useEffect(() => {
        const value = localStorage.getItem(LEGACY_FEATURE_KEY) as LegacyValue;

        if (!value) {
            setLegacy(false);
            return;
        }

        setLegacy(value === 'true');
    }, []);

    useEffect(() => {
        localStorage.setItem(LEGACY_FEATURE_KEY, legacy ? 'true' : 'false');
    }, [legacy]);

    const context = useMemo<LegacyContextType>(() => ({
        legacy: legacy ?? false,
        toggleLegacy: (value?: boolean) => {
            setLegacy(value ?? !legacy);
        },
    }), [legacy]);

    return <LegacyContext value={context}>{children}</LegacyContext>;
}
